export const isWideProduct = (product: { packShotSize?: string }): boolean =>
    product.packShotSize?.toLowerCase() === 'landscape';
